import { explainFirebaseError, isFirebaseConfigured, isPermissionDeniedError } from "data/firebase";
import { listListingInquiriesFromFirestore } from "data/firebase/listingInquiriesApi";

function wrap(error, fallback) {
  if (isPermissionDeniedError(error)) {
    return new Error(
      'Firebase izin hatası: "listingInquiries" koleksiyonu için Firestore kuralları yayında değil. ' +
        "Depodaki firestore.rules dosyasını Firebase Console’dan yayınlayın.",
    );
  }
  const explained = explainFirebaseError(error);
  if (explained && explained !== error?.message) return new Error(explained);
  return error instanceof Error ? error : new Error(fallback);
}

export const listingInquiriesRepo = {
  async list() {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await listListingInquiriesFromFirestore();
    } catch (error) {
      throw wrap(error, "İlan mesajları yüklenemedi.");
    }
  },
};
